import { CssBaseline, Box, Typography, Container } from "@mui/material";

export function BasePage({ title, children, maxWidth = "xs" }) {
 return (
  <Container component="main" maxWidth={maxWidth}>
   <CssBaseline />
   <Box
    sx={{
     marginTop: 8,
     display: "flex",
     flexDirection: "column",
     alignItems: "center",
    }}
   >
    <Typography component="h1" variant="h5" sx={{ mb: 1 }}>
     {title}
    </Typography>
    {children}
   </Box>
  </Container>
 );
}
